export default __webpack_public_path__ + "3c4d6a435abef3186bd2521cdd941bc8.pdf";